module.exports = __webpack_public_path__ + "static/media/27-10.89b6fba0.mp3";